import { render, staticRenderFns } from "./RegistrationFinished.vue?vue&type=template&id=56dc7bf0&scoped=true"
import script from "./RegistrationFinished.vue?vue&type=script&lang=ts"
export * from "./RegistrationFinished.vue?vue&type=script&lang=ts"
import style0 from "./RegistrationFinished.vue?vue&type=style&index=0&id=56dc7bf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56dc7bf0",
  null
  
)

export default component.exports